import { isDate, parse } from "date-fns";
import { parseISO as dfParseISO } from "date-fns/esm";
import { format } from "date-fns-tz";
import { ptBR } from "date-fns/locale";
import _ from "lodash";
import { envs } from "../config";

const defaultPatter = "dd/MM/yyyy";

export const parseDateString = (strValue, pattern) => {
  if (!strValue) {
    return null;
  }
  return isDate(strValue)
    ? strValue
    : parse(strValue, pattern || defaultPatter, new Date());
};

export const parseStringDate = (date = new Date()) => {
  return isDate(date)
    ? date.toLocaleDateString(envs.locale, {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
    : null;
};

export const formatDate = (date, pattern) =>
  format(date, pattern || defaultPatter);

export const formatSimpleDate = (data) =>
  data
    ? format(data, "dd/MM EEEE, 'às' HH'h'", {
        locale: ptBR,
        timeZone: "America/Sao_Paulo",
      })
    : null;

export const yupTransformDateString = (...[, originalValue]) => {
  return parseDateString(originalValue);
};

export const parseISO = (data) => {
  if (!data) {
    return null;
  }
  if (isDate(data)) {
    return data;
  }

  return dfParseISO(data);
};

export const getYearsRange = (baseYear, maxYear) => {
  if (!baseYear) {
    return [];
  }

  const finalYear = maxYear || new Date().getFullYear();

  return "0"
    .repeat(finalYear - 2012)
    .split("0")
    .map((a, i) => {
      return finalYear - i;
    });
};

export const getMonths = (limit = -1) => {
  const currentYear = new Date().getFullYear();

  return "0"
    .repeat(12)
    .split("")
    .map((...[, i]) => {
      return new Date(currentYear, i, 1);
    })
    .filter((d) => limit < 0 || d.getMonth() <= limit)
    .map((d) => {
      return _.capitalize(d.toLocaleDateString("pt-BR", { month: "long" }));
    });
};
